export let duMessages={
  "privacy_policy_and_terms_of_use":"Privacy Policy and Terms of Use ",
  "privacy_confirm_text":"We've updated our <a href='https://www.medtrum.com/privacy_pilicy.html' target='_blank'>Privacy Policy</a> and <a href='https://www.medtrum.com/terms_of_use.html' target='_blank'>Terms of Use</a>. To continue using EasyView, you need to read and agree to all the terms.",
  "privacy_confirm_disagree":"Disagree",
  "privacy_confirm_accept":"Accept",

"title":"EasyView Personal",
"title1":"EasyView Pro",
"user":"E-mail",
  "password":"Wachtwoord",
  "remember":"Onthoud mij",
  "forget":"Wachtwoord vergeten?",
  "sign in":"Inloggen",
"login":"Login",
  "sign up now":"Nu registreren",
  "apply":"Nu aanvragen",
  "contact us":"Neem contact met ons op",
  "Privacy Policy":"Privacybeleid",
  "Terms of Use":"Gebruiksvoorwaarden",
  "copyright":"Copyright © 2021 Medtrum Technologies Inc. Alle rechten voorbehouden.",

"chooseLang":"Kies uw land of taal",
"asia":"Azië",
  "europe":"Europa",

  "applyHcp":"Vraag een zorgverlenersaccount aan",
  "sign up":"Registreren",
"Patient":"Patiënt",
  "Caregiver":"Zorgverlener",
  "Email":"E-mail",
  "Mobile":"Mobiel",
  "Enter email":"Vul e-mailadres in",
  "Enter mobile":"Vul mobiel nummer in",
  "Verification":"Verificatiecode",
"Invitation":"Invitation code",
  "full name":"Vul uw volledige naam in",
"Enter pass":"Vul wachtwoord in",
  "org":"Organisatie",
"Register":"Register",
  "send":"Verzenden",
"agree":"Ik heb het privacybeleid en de ",
"privacy":" servicevoor waarden van Medtrum gelezen  ",
"and" :"en ga ",
"use":"hiermee akkoord.",
"errtip1-1":"U dient een geldig e-mailadres in te vullen,",
"errtip1-2":"dit wordt uw gebruikersnaam voor Medtrum.",
"errtip2":"Please enter a valid mobile number.",
  "errtip3":"Verificatiecode onjuist",
"errtip4":"Incorrect invitation code.",
  "errtip5":"Gebruikersnaam onjuist",
"errtip6":"Your password must have 8 or more characters.",
"errtip7":"Vul uw organisatie in a.u.b.",

"errp1":"Wachtwoord moet tenminste 3 van de volgende soorten tekens bevatten:",
"errp2":"hoofdletter, kleine letter, nummer en speciaal teken. ",
  "errp3":"Wachtwoord moet tussen de 6 en 20 tekens lang zijn.",
  "errp4":"Wachtwoord moet anders zijn dan gebruikersnaam.",
  "errp5":"Wachtwoord met 3 opeenvolgende nummers is ongeldig (bv. 123, 321). ",
  "errp6":"Wachtwoord met 3 opeenvolgende letters is ongeldig (bv. abc, cba).",
  "errp7":"Wachtwoord mag geen spaties bevatten.",

  "Find account":"Herstel uw wachtwoord.",
  "Enter username":"Vul uw gebruikersnaam in a.u.b.",
  "Next":"Volgende",
  "Cancel":"Annuleren",
  "Back":"Terug",
"Enter veri":"Verificatiecode",
  "Verify notice":"Zoek de verificatiecode op die is verzonden in een e-mail.",
  "Create new":"Een nieuwe wachtwoord aanmaken",
  "Create new notice":"Maak een nieuw wachtwoord aan a.u.b., deze dient te bestaan uit 6 of meer tekens.",
"New pass" :"Nieuw wachtwoord",
  "Completed":"Voltooid",
  "Created":"Nieuw wachtwoord aangemaakt.",
  "Login Now":"Nu aanmelden",

  "Delete":"Verwijderen",
"New Patient":"Nieuwe patiënt",
"Add Patient":"Patiënt toevoegen",
  "Filter":"Filter",
  "Name":"Naam",
"Gender":"Geslacht",
  "Age":"Leeftijd",
  "Type":"Type",
"Duration":"Duur",
  "Connections":"Aanmaker van account",
  "UploadTime":"Uploadtijd",
"Year":"jaar ",
"Years":"Jaar",
  "Month":"maand",
  "Month2":"Maand",
  "Months":"maand",
  "Invite":"Uitnodigen",
  "Invited":"Uitgenodigd",
  "All":"Alle",
  "Female":"Vrouw",
"Male":"Man",
"Not Set":"Ongespecificeerd",
  "Type 1":"Type 1",
  "Type 2":"Type 2",
  "Gestational":"Zwangerschaps-",
  "Prediabetes":"Prediabetes",
  "LADA":"Type 1.5 LADA",
"Apply":"Toepassen",
"disUn":"Diabetestype ongespecificeerd",
  "ageUn":"Leeftijd ongespecificeerd",
  "genUn":"Geslacht ongespecificeerd",
  "addP":"Patiënt toevoegen",
  "newP":"Nieuwe patiënt",
  "findP":"Patiënt zoeken",

"GDRNF":"Ongespecificeerd",
"GDRF":"Vrouw",
"GDRM":"Man",
  "女":"Man",

  "DBTNF":"Ongespecificeerd",
"DBT1":"Type 1",
"DBT2":"Type 2",
"DBTLADA":"Type 1.5 LADA",
"DBTPRE":"Prediabetes",
"DBTGEST":"Zwangerschaps-",
"前期":"beFore",
"beFore":"beFore",
"MODY":"Mody",

"No selection":"Ongespecificeerd",
"unspecif":"Ongespecificeerd",
  "register":"Patiënt",
  "hcp":"Arts",

  "BG":"BG",
"CARB":"Koolhydraten",
"INS":"Injectie",
  "EXR":"Inspanning",
"OTR":"Anders",
"HBA1C":"HbA1c",
"DOSE":"Dosis",
  "URINEK":"Ketonen in urine",
"HEL":"HEL",
  "OTR1":"Anders",
  "Loading":"Aan het laden",

  "home":"Start",
  "pID":"Patiënt-ID",
  "fullName":"Volledige naam",
  "gender":"Geslacht",
  "height":"Lengte",
  "weight":"Gewicht",
  "cm":"cm",
  "kg":"kg",
  "birthday":"Geboortedatum",
  "disType":"Diabetestype",
  "disDate":"Diagnosedatum",
  "Address":"Adres",
  "Postcode":"Postcode",
  "Inpatient":"Intramuraal",
  "Yes":"Ja",
  "No":"Nee",
  "Pno":"Patiëntnr.",
  "Bno":"Bednr.",
  "create":"Aanmaken",
  "Telephone":"Telefoon",

"enterU":"Vul gebruikersnaam in (e-mail)",
  "search":"Zoeken",
  "noU":"Gebruikersnaam is verplicht.",
"searchR":"Zoekresultaten",
  "uername":"Gebruikersnaam",
  "alias":"Bijnaam",
"remove":"Verwijderen",
  "viewG":"Grafieken bekijken",
"sendR":"Verzend verzoek",
  "rSent":"Uw verzoek is verzonden.",
"cancelR":"Verzoek annuleren",

"VcodeTip1":"Niet ontvangen? Wacht a.u.b. een minuut en ",
"VcodeTip2":"probeer het opnieuw.",
"VcodeTip3":"We hebben net een verificatiecode verstuurd naar ",
"Entercode":"Vul code in",
"Getcode":"Verstuur code",

  "messages":"Berichten",
"profile":"Profiel",
  "sign out":"Afmelden",
  "changeP":"Wachtwoord wijzigen",
"connection":"Connections",

  "myP":"Mijn profiel",
  "Portrait":"Profielfoto",
  "Profession":"Beroep",
"DPRONF":"Ongespecificeerd",
  "DPROENDOCRIN":"Endocrinoloog",
  "DPRODIABTRA":"Diabetesverpleegkundige",
  "DPRONURSE":"Verpleegkundige",
  "DPRODIATIT":"Diëtist",
  "DPROOTR":"Andere zorgverleners",
"Organization":"Organisatie",
  "Bio":"Bio",
  "save":"Opslaan",
  "oldPa":"Oude wachtwoord",
  "newPa":"Nieuwe wachtwoord",
  "RePa":"Vul wachtwoord opnieuw in",
  "forgetY":"Uw wachtwoord vergeten?",
  "applyM":"Toepassen",
"oldErr":"Het oude wachtwoord is onjuist.",
"EntTheSame":"Vul het nieuwe wachtwoord opnieuw in.",
"EnterOld":"Vul het oude wachtwoord in.",

  "pList":"Patiëntenlijst",
  "connections":"Connecties",
  "settings":"Instellingen",
  "monitor":"Controleren",
  "graphs":"Verslagen",
  "events":"Gebeurtenissen",
  "records":"Archief",
  "qPrint":"Snel afdrukken",

  "sensorIn":"Sensorinfo",
  "timeOfLaRead":"Tijd van laatste sensorlezing ",
  "tranSn":"SN van de zender ",
  "status":"Status ",
  "sensorLife":"Resterende levensduur van de sensor ",
  "lastSenorRead":"Laatste sensorlezing",
  "TranBattery":"Zenderbatterij",
"sg":"SG",
  "alert":"Waarschuwing",
"target":"Doel",
  "hypo":"Hypo",
  "sensorGlucose":"Sensorglucose",
  "calib":"Kalibratie",
  "newSen":"Nieuwe Sensor",
"warm":"Opwarmen",
"InsulinPump":"Insulinepomp",
  "timeOfLaPump":"Tijdstip van laatste pompgegevens ",
"pumpSN":"SN van de pomp",
  "ReserviorLife":"Resterende levensduur van het reservoir ",
  "InsulinLeft":"Resterende insuline ",
  "basal":"Basaal",
  "bolus":"Bolus",
  "totalBasal":"Totale dagelijkse basaal",
  "lastBolus":"Laatste bolus",
  "activeInsulin":"Actieve insuline",
  "totalBolus":"Totale dagelijkse bolus ",
"tampBasal":"Tijd. Basaal",
  "normalBolus":"Normale Bolus",
  "extendBolus":"Verlengde Bolus",
  "manualStop":"Handmatige Onderbreking",
  "autoStop":"Automatische Onderbreking",
"auto suspend":"Automatische Onderbreking",
  "stop":"Toedieningsstop",
  "newPatch":"Nieuw Reservoir",
  "tempBasal":"Tijd. Basaal",
  "N":"N",
  "E":"V",
  "CN1":"GN",
  "CE":"GV",

  "staticSettings":"Verslaginstellingen",
  "dataSource":"Gegevensbron",
  "unit":"Eenheid ",
  "glucoseTarget":"Glucosestreefniveau",
  "overall":"Algemeen",
  "Hypoglycemia":"Hypoglykemie",
  "timePeriod":"Tijdsperiode",
  "postMeal":"Post-maaltijdanalyse",
  "Breakfast":"Ontbijt",
  "Lunch":"Lunch",
  "Dinner":"Diner",
  "night":" 's Nachts",
  "Before":"Voor",
  "After":"Na",
"Low":"Laag",
  "High":"Hoog",
  "From":"Van",
  "To":"Tot",
"Hours":"uren",
  "Reset":"Herstel fabrieksinstellingen",
  "RealTime":"Real-time",
"uploaded":"Bijgewerkt",
  "sensor":"Sensor",
  "pdmSN":"SN van de PDM",
  "startTime":"Begintijd",
  "endTime":"Eindtijd",
"uploadTime":"Uploadtijd",
  "pdm":"PDM",
  "Uploaded":"Bijgewerkt",
  "Patch Pump":"PDM",
"overLapp":"Sessies overlapten",
  "showAlert":"Toon meldingen",

  "dashboard":"Dashboard",
  "dboard_glucose_statistics":"Statistieken",
  "dboard_glucose":"Glucose",
  "dboard_cgm":"CGM",
  "dboard_insulin":"Insuline",
  "dboard_carbs":"Koolhydraten",
  "dboard_exercise":"Inspanning",
  "dboard_glucose_avg":"Gemiddelde",
  "dboard_cgm_avg":"Gemiddelde",
  "dboard_insulin_avg":"Gemiddelde dagelijkse dosis",
  "dboard_carbs_avg":"Gemiddelde koolhydraten/dag",
  "dboard_exercise_avg":"Gemiddelde tijd/dag",
  "dboard_sd":"SD",
  "dboard_num":"#",
  "dboard_num_days":"# days",
  "dboard_statistics":"Statistieken",
  "dboard_BG":"BG",
  "dboard_BG_calibration":"BG/kalibratie (per dag)",
  "dboard_SG":"SG",
  "dboard_AUC_high":"AUC hoog >",
  "dboard_AUC_low":"AUC laag <",
  "dboard_highest_value":"Hoogste waarde",
  "dboard_lowest_value":"Laagste waarde",

  "dboard_pump":"Pomp",
  "dboard_avg_daily_dose":"Gemiddelde dagelijkse dosis",
  "dboard_SD":"SD",
  "dboard_daily_basal":"Dagelijkse basaal",
  "dboard_daily_bolus":"Dagelijkse bolus",
  "dboard_avg_bolus_num":"Gemiddeld aantal bolussen per dag",
  "dboard_avg_suspend_time":"Gemiddelde onderbrekingstijd",
  "dboard_avg_reservoir_usage":"Gemiddeld reservoirgebruik",
  "dboard_days":"days",

  "dboard_manual_bolus":"Handmatige bolus (volume/aantal per dag)",
  "dboard_normal":" -Normaal",
  "dboard_extend":" -Verlengd",
  "dboard_combo":" -Gecombineerd",

  "dboard_bolus_calculator":"Boluscalculator (volume/aantal per dag)",
  "dboard_food_bolus":" -Maaltijdboluscalc.",
  "dboard_corr_bolus":" -Correctieboluscalc.",
  "dboard_override_add":" -Overschrijding(+)",
  "dboard_override_sub":" -Overschrijding(-)",

  "dboard_report":"Dashboard aanmaken",

"daily":"Dagelijks Overzicht",
  "date":"Datum",
  "print":"Afdrukken",
  "carbs":"Koolhydraten",
"exercise":"Inspanning",
  "heavy":"Zwaar",
  "Medium":"Medium",
  "Light":"Licht",
  "dailyReport":"Dagelijks Overzichtsverslag",
  "devices":"Apparaten",
  "tran":"Zender",
  "pumpBase":"Pomp",
"HbA1c":"HbA1c",
"statics":"Statistieken",
  "glucose":"Glucose",
  "item":"Item",
"BG1":"BG",
  "SG1":"SG",
"avgSD":"Gem (mmol/L)±SD",
  "avgSD1":"Gem±SD",
  "min":"Min",
  "max":"Max",
  "ofRead":"Aantal lezingen",
"ofHypo":"Aantal hypo's/duur(min)",
  "ofAlert":"Aantal waarschuwingen",
"insulin":"Insuline",
  "insulin2":"Insuline",
"totalDose":"Totale dagelijkse dosis",
"foodBolus":"Maaltijdbolus",
"Food+coor":"Food+corr",
"calibBolus":"Correctiebolus",
"durationStop":"Duur van onderbreking (min)",
  "ofPumpAlert":"Aantal pompalarmen",
  "ofMeal":"Aantal maaltijden",
  "totalExerTime":"Totale inspanningstijd",
  "exerNum":"Aantal inspanningen",
"avgInten":"Gem Intensiteit",
  "target1":"Doel",
"high1":"Hoog ",
"low1":"Laag",
"BG Reading":"BG-lezingen",

  "dayByday":"Overzicht per dag",
"dayBydayRe":"Dagelijks Overzichtsverslag",
  "period":"Periode",

  "sensorOverlay":"Sensor Overzicht",
  "set":"Instellen",
  "setPeriod":"Stel periode in",
  "Weekdays":"Doordeweeks",
  "Weekends":"Weekends",
  "Mon":"Ma",
  "Tue":"Di ",
  "Wed":"Wo",
  "Thur":"Do",
  "Thu":"Do",
  "Fri":"Vr",
  "Sat":"Za",
  "Sun":"Zo",
"Average":"Gemiddeld",
  "sensorOlRe":"Overzichtsverslag Sensor",
  "Avg":"Gem",
"±SD":"±SD",
"ofhypo":"Aantal Hypo's",
  "Everyday":"dagelijks",

"TrendAna":"Trendanalyse",
  "TrendRe":"Trendanalyse-verslag",
"sensorGlu":"Sensorglucose ",
  "ofBGtest":"Aantal BG-testen",
  "Basics":"Basis",
  "static":"Statistieken",
  "Med":"Med",
"med":"Med",
"Q1":"Q1",
"Q3":"Q3",
"Q11":"Q1",
"Q31":"Q3",
  "IQR":"IQR",
"SD":"SD",
  "CV":"CV",
  "SE1":"SEM",
"distri":"Spreiding",
  "stab":"Stabiliteit",
  "#high":"Aantal hoge",
  "#low":"Aantal lage",
"aucBelow":"AUC onder de grens",
"aucAbove":"AUC boven de grens",
  "bgRead":"BG-lezingen",
"total":"Totaal",
"ofBolus":"Aantal bolussen",
"avgBolus":"Gem. bolu",
  "Dura1":"Duur (min)",
  "Avg/Total":"Gem/Totaal",
"high":"Hoog",
  "low":"Laag",
  "#hypo":"Aantal Hypo's",
  "ofExer":"Aantal inspanningen",

  "logbook":"Logboek",
  "dailyTotal":"Dagelijks Totaal",
  "High Glucose":"Hoge Glucose",
  "Low Glucose":"Lage Glucose",
  "No Active Patch":"Geen Actief Reservoir",
  "Missed Meal":"Gemiste Maaltijd",
  "Multiple BG Readings":"Meerdere BG-lezingen",
  "Stop Patch":"Reservoir Stoppen",
  "Others":"Anders",
  "Other Events":"Andere gebeurtenissen",
  "logRe":"Logboekverslag",

  "DeviceSetting":"Inspectie Apparaatinstellingen",
  "Insulin Pump":"Insulinepomp",
  "MaxBasalRate":"Maximale Basaalsnelheid",
  "BasalPatterns":"Basaalschema's",
  "Selected Basal Pattern":"Geselecteerde Basaalschema",
  "Maximum Bolus":"Maximale Bolus",
  "Combo/Extended Bolus":"Gecombineerde/Verlengde Bolus",
  "BG Reminder":"BG-herinnering",
  "Bolus Increment":"Stapgrootte van de Bolus",
  "Bolus Calculator":"Boluscalculator",
  "Active Insulin Time":"Actieve Insulinetijd",
"IC Ratios":"I:KH Ratio's",
  "Insulin Sensitivity":"Insulinegevoeligheid",
  "BG Target":"BG-doel",
  "Bolus Reminder":"Bolusherinnering",
  "CGM":"CGM",
  "CGM System":"CGM-systeem",
  "Glucose Unit":"Glucose-eenheid",
  "Glucose Limits":"Glucoselimieten",
  "Predicitive Alerts":"Voorspelde Waarschuwingen",
  "Rate Alerts":"Snelheidswaarschuwingen",
"type":"Type",
"time":"Tijd",
  "data":"Gegevens",
"Rate":"Rate",
  "Calibration Reminder":"Kalibratieherinnering",
  "Calibration Repeat":"Kalibratieherhaling",
  "Snooze":"Sluimerfunctie",
  "Audio Options":"Geluidsopties",
  "Confidence Reminder":"Herinnering",
  "Backlight":"Schermverlichting",
  "Sec":"sec",
  "Alarm Clock":"Wekker",
  "Patch Expiration":"Vervaldatum Reservoir",
  "Sensor Expiration":"Vervaldatum Sensor",
  "Hourly Max":"Max per Uur",
  "Daily Max":"Dagelijkse Max",
  "Low Reservoir":"Reservoir bijna leeg",
"Low Suspend":"Lage Stopwaarde",
  "Predictive Low Suspend":"Voorspelde Lage Stopwaarde",
  "Rise":"Stijgen",
  "Fall":"Dalen",
"Auto Off":"Auto Uit",
  "Standard":"Standaard",
"Exercise":"Exercise",
  "Holiday":"Vakantie",
  "ProgramA":"Schema A",
  "ProgramB":"Schema B",
"--":"--",
"Insulin":"Insulin",

  "SUSA":"Auto Uit",
  "SUSHM":"Max. dosis per uur overschreden",
  "SUSDM":"Max. dagelijkse dosis overschreden",
"SUSLSG":"Lage Stopwaarde",
"SUSPLSG":"Voorspelde Lage Stopwaarde",
  "Pump Restarted":"Pomp herstart",
"Meter BG Now":"BG direct meten",
  "Sensor Exp in 2 Hours":"Sensor vervalt binnen 2 uur",
"Sensor Exp in 6 Hours":"Sensor vervalt binnen 6 uur",
  "Sensor Exp in 30 Min":"Sensor vervalt binnen 30 min",
  "Sensor Calibration Error":"Sensor-kal. Fout",
  "Sensor Error":"Geen metingen",

  "Device Settings Report":"Apparaatinstellingen Verslag",
  "24h Total":"24-uurs Totaal",
"Device Settings at":"Apparaatinstellingen op",
  "Start":"Begin",
  "Combo/Ext Bolus":"Gecom./Verl. Bolus ",
  "Time Format":"Tijdnotatie",
"Device Options（CGM System)":"Apparaatopties (CGM-systeem)",
"Device Options（Insulin Pump)":"Apparaatopties (Insulinepomp)",
  "Dispay Settings (Screen)":"Weergave-instellingen (scherm) ",
  "Dispay Settings (Backlight)":"Weergave-instellingen (schermverlichting)",
  "Graph Range":"Grafiekbereik",
"Range":"Range",
  "Repeat":"Herhalen",
  "Glucose Alerts":"Glucose-waarschuwingen",
  "Alert Silence":"Waarschuwingen dempen",

"Create":"Aanmaken",
  "Event Filter":"Gebeurtenissenfilter",
  "HbA1c1":"HbA1c",
"Urine Ketone":"Ketonen in urine",
  "Injection":"Injectie",
"Other":"Anders",
  "Event Type":"Gebeurtenistype",
  "Details":"Details",
  "Notes":"Opmerkingen",
  "Source":"Bron",
  "edit":"Bewerken",
  "Action":"Actie",
  "EventReport":"Overzichtsverslag Gebeurtenissen",
  "By Date":"Op Datum",
  "By Category":"Op Categorie",
  "Event Summary":"Samenvatting Gebeurtenissen",
  "No data":"Geen gegevens",
"No1":"Geen",
"data1":"gegevens",
"#":"#",
  "BG Summary":"Samenvatting BG",
  "Carbs Summary":"Samenvatting Koolhydraten",
  "Injection Summary":"Samenvatting Injecties",
  "Exercise Summary":"Samenvatting Inspanning",
  "Input Notes":"Opmerking invoeren",

  "Profile":"Profiel",
  "Complications":"Complicaties",
  "Concomitant diseases":"Bijkomende aandoeningen",
"Suggestion":"Suggestie",
  "Coronary heart disease":"Coronaire hartziekte",
"High blood lipids":"Hyperlipidemie",
"High blood pressure":"Verhoogde bloeddruk",
"Kidney disease":"Nierziekte",
"Neuropathy":"Neuropathie",
"Obesity":"Overgewicht",
"Peripheral arterial disease":"Perifeer arterieel vaatlijden",
"Retinopathy":"Retinopathie",
"Smoking addiction":"Rookverslaving",
  "Enter date":"Vul datum in",
  "Enter suggestion":"Vul suggestie in",
"Enter Notes":"Voeg opmerking toe",
  "Select":"Selecteren",
  "Prescription":"Recept",
  "Medicine":"Medicijn",
  "Dose":"Dosis",
  "Enter medicine":"Vul medicatie in",
  "Enter dose":"Vul dosis in",
"Enterdis":"Enter concomitant diseases",
  "Add note":"Voeg opmerking toe",
"Add Content":"Maximale lengte is 1000 tekens.",
  "Other suggestions":"Andere suggesties",
  "OK":"OK",
  "HCP":"Zorgverleners",
  "Content":"Inhoud",
  "Records Report":"Archiefverslag",

"Quick Print":"Snel afdrukken",
  "Quick Print Settings":"Instellingen Snel Afdrukken",
"Select duration":"Selecteer duur",
  "One Week":"Een week",
  "One Month":"Een maand",
  "One Quarter":"Een kwartaal",
  "End date":"Einddatum",
  "Yesterday":"Gisteren",
  "Last Sunday":"Afgelopen zondag",
  "Last Saturday":"Afgelopen zaterdag",
"Last Day of Last Month":"Last Day of Last Month",
"Last Day of Last Quarter":"Last Day of Last Quarter",
"Customized":"Aanpassen",
  "Week Filter":"Weekfilter",
  "Select reports to print":"Selecteer verslagen om af te drukken",
  "Daily Summary":"Dagelijks Overzicht",
"Day By Day Overview":"Overzicht per dag",
"Sensor Overlay":"Sensor Overzicht",
  "Trend Analysis":"Trendanalyse",
"Logbook":"Logboek",
"Device Settings Review":"Inspectie Apparaatinstellingen",
  "createReport":"Verslag aanmaken",

  "Segment Analysis":"Segmentanalyse",
  "Sensor Glucose Profile":"Sensorglucoseprofiel",
  "# of Boluses":"Aantal bolussen",
"Bolus Insulin":"Bolusinsuline ",
"Basal Pattern":"Basaalschema ",
"Segment Analysis Report":"Verslag van segmentanalyse",
"Avg Glucose":"Gem. glucose",
"Below":"Onder",
  "In Target Range":"Binnen streefniveau",
  "Coefficient of variation":"Variatiecoëfficiënt",
  "% Time CGM Active":"% tijd CGM actief",
  "est_a1c_t1":"Geschatte A1C:",
  "est_a1c_t2":"berekend op basis van SG-waarden",
  "est_a1c_t3":"Opmerking: Geschatte A1C is geen vervanging voor laboratoriummeting",

"acceptTip":" staat u toe zijn/haar gezondheidsinformatie van op afstand te bekijken.",
"cancelTip":" staat niet langer toe dat u zijn/haar gezondheidsinformatie van op afstand bekijkt. U kunt indien nodig opnieuw een verzoek doen.",
"rejectTip":" heeft uw verzoek geweigerd om zijn/haar gezondheidsinformatie van op afstand te bekijken.",
  "Read":"Lees",

  "Connection":"Connectie",
"connections1":"Connecties",
  "Add Connection":"Voeg connectie toe",
"SG":"SG",
  "Active Insulin":"Actieve Insuline",
  "Stop following":"Stop met volgen",
  "Enter username (email)":"Vul gebruikersnaam in (e-mail)",
  "Search results":"Zoekresultaten",
  "Send request":"Verzend verzoek",
"View graphs":"Bekijk grafieken",
  "Agree":"Accepteer",
  "Deny":"Weiger",
  "Remove":"Verwijderen",
  "Cancel Requset":"Verzoek annuleren",
  "Remark":"Opmerking",

  "Warm up":"Opwarmen",
  "Monitoring":"Aan het controleren",
"Transmitter Error":"Zenderfout",
"Sensor Failure":"Sensorstoring",
  "Sensor Expired":"Sensor vervallen",
  "Lost Sensor":"Sensor verloren",
  "Not Calibrated":"Niet gekalibreerd",
  "Calibrating":"Aan het kalibreren",
  "Calibration Needed":"Kalibratie benodigd",
  "Calibration Error":"Kalibratiefout",
  "Charging Battery":"Batterij wordt opgeladen",
  "Battery Charged":"Batterij opgeladen",

  "To be filled":"Moet worden gevuld",
  "Filled with insulin":"Gevuld met insuline",
  "Priming":"Aan het voorbereiden",
  "Priming completed":"Voorbereiden voltooid",
  "Inserting needle":"Naald wordt ingebracht",
  "Patch activated":"Reservoir geactiveerd",
  "Delivering Basal":"Basaal wordt toegediend",
"Exceeds Max 1 Hour Delivery":"Max. dosis per uur overschreden",
"Exceeds Max TDD":"Max. dagelijkse dosis overschreden",
  "Suspend":"Stoppen",
  "Occlusion Detected":"Verstopping gedetecteerd",
  "Patch Expired":"Reservoir Vervallen",
"Empty Reservoir":"Leeg Reservoir",
"Patch Error":"Reservoirfout",
"Pump Base Error":"Pompfout",
  "Patch Battery Depleted":"Reservoirbatterij Leeg",
  "Magnetic sensor not calibrated":"Magnetische sensor niet gekalibreerd",

"Patient Profile":"Patiëntenprofiel",

"On":"Aan",
  "on":"Aan",
"Off":"Uit",
  "off":"Uit",

"CORONARY_HEART_DISEASE":"Coronaire hartziekte",
  "HIGH_BLOOD_LIPIDS":"Hyperlipidemie",
  "HIGH_BLOOD_PRESSURE":"Verhoogde bloeddruk",
  "KIDNEY_DISEASE":"Nierziekte",
  "NEUROPATHY":"Neuropathie",
  "OBESITY":"Overgewicht",
  "PERIPHERAL_ARTERIAL_DISEASE":"Perifeer arterieel vaatlijden",
  "RETINOPATHY":"Retinopathie",
  "SMOKING_ADDICTION":"Rookverslaving",

  "saveTip":"Succesvol opgeslagen.",
  "changePaTip":"Uw wachtwoord is gewijzigd.",
  "enterEmTip":"Vul uw e-mailadres in.",
  "verErrTip":"Verificatiecode onjuist.",
  "chooseEventTip":"Kies gebeurtenissen om af te drukken",
"chooseDataTip":"Selecteer gegevens om af te drukken",
"dateWrongTip":"De einddatum mag niet eerder zijn dan de begindatum.",
  "infoWrongTip":"Vul alle verplichte velden in a.u.b.",
"createdSuccssTip":"Succesvol aangemaakt",
"selectData":"Selecteer gegevens om op te slaan",

"acceSu":"Connectieverzoek geaccepteerd",
"acceEr":"Nieuwe connectie toevoegen mislukt",
"rejeSu":"Connectieverzoek afgewezen",
"rejeEr":"Verzoek afwijzen mislukt",

  "userNotExist":"De gebruikersnaam bestaat niet.",
  "Password incorrect":"Wachtwoord onjuist.",
"UserType incorrect":"Onjuist gebruikerstype",

"registSuccess":"Uw account is succesvol aangemaakt.",
"registFailed":"Nieuw account aanmaken mislukt.",
"sentSuccess":"Bericht succesvol verzonden",
"sentFailed":"Bericht versturen mislukt",
  "Input error":"Invoerfout",

  "deletePtip":"Weet u zeker dat u deze patiënten wilt verwijderen?",
  "deleteEvents":"Weet u zeker dat u deze gebeurtenissen wilt verwijderen?",
  "deleteData":"Real-time and uploaded data will be deleted. The deleted data can't be restored. Are you sure to delete data?",
  "deleteThis":"Weet u zeker dat u dit wilt verwijderen?",
  "confirm":"Bevestigen",
"deleteSuccess":"Succesvol verwijderd",
"deleteFailed":"Item verwijderen mislukt",
"modifySuccess":"Succesvol veranderd",
"modifyFailed":"Veranderen mislukt",
  "createSuccess":"Succesvol aangemaakt",
  "createFailed":"Aanmaken mislukt",
  "editSuccess":"Bewerking succesvol",
  "editFailed":"Bewerken mislukt",
"Time overlapped":"De door u geselecteerde sessies overlapten elkaar.",

  "stopFollow":"Weet u zeker dat u deze patiënt niet meer wilt volgen?",
"CancelTip1":"Weet u zeker dat u deze connectie wilt verwijderen?",

  "Warning":"Waarschuwing",
"agreeConnect":"Als u op 'Accepteren' klikt om het connectieverzoek te accepteren, wordt uw gezondheidsinformatie zichtbaar voor de nieuwe connectie.",
"denyConnect":"Weet u zeker dat u het connectieverzoek wilt afwijzen?",
"deleteConnect":"Weet u zeker dat u deze connectie wilt verwijderen? Als u hem/haar verwijderd, kan de connectie uw gezondheidsinformatie niet meer zien.",

"Choose the events to print":"Kies gebeurtenissen om af te drukken",
  "tryAgain":"Probeer opnieuw",
"username and password is required":"username and password is required",
"A name is required":"Een naam is verplicht.",
"username is required":"Gebruikersnaam is verplicht.",
  "The date choose wrong":"Onjuiste datumselectie",
"Date no more than 14 days":"U kunt niet meer dan 14 dagen selecteren.",

"CancelTip":"Weet u zeker dat u de connectie wilt verwijderen?",
  "removeConnect":"Succesvol verwijderd",

"dateErr1":"U kunt niet meer dan 90 dagen selecteren.",
  "dateErr2":"De einddatum mag niet eerder zijn dan de begindatum.",

"Not Filled":"Ongespecificeerd",
  "Today":"Vandaag",
  "duration":"Duur",
  "interval":"Interval",
  "7 days":"7 dagen",
  "14 days":"14 dagen",
"30 days":"30 dagen",
"90 days":"90 dagen",
"g":"g",

  "Sound+Vibrate":"Geluid+Trillen",
"Sound":"Geluid",
  "Vibrate":"Trillen",
  "Silent":"Niet storen",
"1":"Eenmalig",
  "2":"Dagelijks",
"noMes":"Er zijn geen berichten.",
"noConnect":"Er zijn geen connecties.",
  "Customize":"Aanpassen",
"GB":"United Kingdom",
"CN":"China",
"FR":"France",
"DD":"Germany",
"DE":"Germany",
"SE":"Sweden",
"AU":"Australia",
"HKF":"Hongkong",
"HU":"Hungary",
"IT":"Italy",
"NL":"Netherlands",
"Nor":"Norway",
"PT":"Portugal",
"ES":"Spain",
"TR":"Turkey",

  "Jan":"jan",
  "Feb":"feb",
  "Mar":"maa",
  "Apr":"apr",
  "May":"mei",
  "Jun":"jun",
  "Jul":"jul",
  "Aug":"aug",
  "Sep":"sep",
  "Oct":"okt",
  "Nov":"nov",
  "Dec":"dec",
  "ApplyTip":" verzoek om uw gegevens te bekijken.",
  "noReadings":"Geen metingen",

  "daop_A6_system":"A6 Touchcare System",
  "daop_easytouch_easyview":"EasyTouch / EasyView iPad",
  "daop_TY012_TY015":"TY012/TY015",
  "daop_easysense":"EasySense",
  "daop_delete_data":"Delete Data",
  "daop_uploaded_data":"Geüploade gegevens",
  "daop_uploaded_data_text":"De gegevens zijn afkomstig van de EasyTouch-app of de EasyView iPad-app.",
  "daop_realtime_data":"Real-time gegevens",
  "daop_realtime_data_text":"The data is from EasySense App or EasyPatch App.",

  "ins_unit":"( E ) ",
  "ins_unit2":"E",
  "basal_unit":"(E/u)",
  "basal_unit2":"E/u",

  // 告警
  "Alerts_Patch_Battery_Low":"Reservoirbatterij bijna leeg",
  "Alerts_Patch_Battery_Depleted":"Reservoirbatterij leeg", // update
  "Alerts_Lost_Pump":"Lost Pump",
  "Alerts_Low_Reservoir":"Reservoir bijna leeg", // update
  "Alerts_Empty_Reservoir":"Leeg Reservoir",
  "Alerts_Patch_Expiration_Advisory":"Reservoir-verval Herinnering",
  "Alerts_Patch_Exp_In_1_Hour":"Patch Exp In 1 Hour",
  "Alerts_Patch_Expired":"Reservoir Vervallen", // update
  "Alerts_Patch_Error":"Reservoirfout",
  "Alerts_Pump_Base_Error":"Pompfout",
  "Alerts_Basal_Rate_Key_Error":"Basal Rate Key Error",
  "Alerts_Occlusion_Detected":"Verstopping Gedetecteerd", // update
  "Alerts_End_Of_Suspend":"End Of Suspend",
  "Alerts_Exceeds_Max_TDD":"Max. dagelijkse dosis overschreden", // update
  //"Alerts_Exceeds_Max_TDD":"Exceeds Max TDD",
  "Alerts_Exceeds_Max_1Hr_Delivery":"Max. toediening per uur overschreden",
  //"Alerts_Exceeds_Max_1Hr_Delivery":"Exceeds Max 1Hr Delivery",
  "Alerts_Predictive_Low_Suspend":"Voorspelde Lage Stopwaarde", // update
  "Alerts_Low_Suspend":"Lage Stopwaarde",
  "Alerts_Auto_Off":"Auto Uit  ", // update

  "Alerts_Pump_Restart":"Pump Restart",  // 22
  "Alerts_Auto_Off_Warning":"Auto Off Warning",  // 23
  "Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //24
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  // 25
  //"Alerts_Pump_Out_Of_Range":"Pump Out Of Range",  //33

  "Alerts_Lost_Sensor":"Sensor Verloren", // update
  "Alerts_Transmitter_Battery_Low":"Zenderbatterij bijna leeg",
  "Alerts_Charge_Transmitter":"Laad Zender Op",
  "Alerts_Sensor_Error":"Geen metingen",
  "Alerts_Transmitter_Error":"Zenderfout",
  "Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  //"Alerts_Sensor_Calibration_Error":"Sensor Calibration Error",
  "Alerts_Sensor_Failure":"Sensorstoring",
  "Alerts_Sensor_Calibration_Reminder":"Sensor Calibration Reminder",
  "Alerts_Meter_BG_Now":"BG direct meten",
  "Alerts_Sensor_Exp_in_6_Hours":"Sensor vervalt binnen 6 uur",
  "Alerts_Sensor_Exp_in_2_Hours":"Sensor vervalt binnen 2 uur", // update
  "Alerts_Sensor_Exp_in_30_Min":"Sensor vervalt binnen 30 min",
  "Alerts_Sensor_Expired":"Sensor vervallen", // update
  "Alerts_Rapid_Rise":"Snelle Stijging",
  "Alerts_Rapid_Fall":"Snelle Daling",
  "Alerts_High_Predicted":"Hoog Verwacht",
  "Alerts_Low_Predicted":"Laag Verwacht",
  "Alerts_High_Glucose":"Hoge Glucose", // update
  "Alerts_Low_Glucose":"Lage Glucose", // update
  "Alerts_Below_3.1_mmol/L":"Onder 3,1 mmol/L",
  "Alerts_Transmitter_Battery_Low_2":"Zenderbatterij bijna leeg",

  "Alerts_PDM_Battery_Low":"PDM-batterij bijna leeg",
  "Alerts_Replace_Battery":"Laad de PDM nu op ",

  // Alert页面
  "Alert":"Alert",
  "Alerts":"Waarschuwingen",
  "Alert Filter":"Alert Filter",
  "PDM":"PDM",
  "Pump":"Pomp",
  //"CGM":"CGM",
  "Out Of Range": "Out Of Range",
  "t1221_Time_in_Auto_Mode":"Tijd in Auto Modus",
  "t1221_Average_SG_SD":"Gemiddelde  SG ± SD",
  "t1221_Time_in_Target_Range":"Tijd binnen Streefbereik",
  "t1221_Time_above_Range":"Tijd boven Streefbereik",
  "t1221_Time_below_Range":"Tijd onder Streefbereik",
  "t1221_Auto_Basal_per_day":"Auto Basaal (per dag)",
  "t1221_Auto_Bolus_per_day":"Auto Bolus (per dag)",
  "t1221_Auto_Mode_Exits":"Auto Modus Exit",
  "t1221_No_Sensor_readings":"Geen Sensor waardes",
  "t1221_Max_Delivery":"Max. Toediening",
  "t1221_Min_Delivery":"Min. Toediening",
  "t1222_autoModeBasal":"Auto Modus Basaal",
  "t1222_autoModeCorrBolus":"Auto Modus Correctie Bolus",
  "t1222_autoSnack":"Auto Snack",
  "t1222_autoBreakfast":"Auto Ontbijt",
  "t1222_autoLunch":"Auto Lunch",
  "t1222_autoDinner":"Auto Diner",
  "t1222_autoExercise":"Auto Inspanning",
  "t1222_Snack":"Snack",
  "t1222_Auto_Mode":"Auto Modus",
  "t1222_Time_in_Auto_Mode":"Tijd in Auto Modus(%)",
  "t1222_Avg_SD":"Gemid.(mmol/L)±SD",
  "t1222_Target_Range":"Streefbereik (%)",
  "t1222_Above_Range":"Boven Streefbereik (%)",
  "t1222_Below_Range":"Onder Streefbereik(%)",
  "t1222_Auto_Mode_Exits":"# van Auto Modus Exit",
  "t1221_Auto_Mode":"Auto Modus",
  "t1222_auto_basal":"Auto Basaal",
  "t1222_auto_bolus":"Auto Bolus",
  "t0805_User_Management":"Gebruikersbeheer",
  "t0805_Patient_Management":"Patiëntbeheer",
  "t0805_Operation_History":"Operatie geschiedenis",
  "t0805_User_List":"gebruikers lijst",
  "t0805_User":"Gebruiker",
  "t0805_Time":"Tijd",
  "t0805_Operation_Type":"Bewerkingstype",
  "t0805_Back":"Terug",
  "t0805_Add":"Toevoegen",
  "t0805_Delete":"Verwijderen",
  "t0809_Add_User":"Voeg gebruiker toe",
  "t1028_Pattern_C":"Schema C",
  "t1028_Pattern_D":"Schema D",
  "t1029_Auto_meal_bolus":"Auto Maaltijd Bolus",
  "t1029_Auto_mode_correction_bolus":"Auto Mode Maaltijd Correctie Bolus",
  "t1029_Sick":"Ziek",
  "t1029_Auto_Mode_Feature":"Automatische modus",
  "t1029_Target_SG":"Doel SG",
  "t1029_Auto_Meal_Handling":"Auto. maaltijdverwerking",
  "t1029_Total_Daily_Dose":"Totale dag. Dosis",
  "t1029_Pump_Light":"Pomp Licht",
  "t1029_Alerts_for_Hypo":"Waarschuwingen voor Hypo",
  "t1102_Out_of_Range":"Buiten Bereik",
  "t1102_Command_Reminder":"Opdracht",
  "t1102_Alarms_Alerts_on_APP":"Pomp Alarmen & Waarschuwingen ",
  "t1102_Alarms_on_App":"App Alarmen",
  "t1102_Alerts_on_App":"App Waarschuwingen ",
  "t1102_Factory_Calibration":"Fabrieks Kalibratie",
  "t1102_Alerts_for_Low":"Hypo-waarschuwingen",
  "t1102_Alerts_for_High":"Hyper-waarschuwingen",
  "t1102_Alerts_for_Others":"Overige waarschuwingen",
  "t1102_Adjustment":"Aanpassing",
  "t1102_Suggested":"Voorgesteld",
  "t1103_Glucose":"Glucose",
  "t1103_CGM":"CGM",
  "t1103_Insulin":"Insuline",
  "t1103_Carbs":"Koolhydraten",
  "t1103_Exercise":"Inspanning",
  "t1103_Min_Max":"Min/Max",
  "t1103_Target_Range":"Doel bereik",
  "t1103_Overall_Tine_In_Range":"Algemeen: Time in Range",
  "t1103_Basal":"Basaal",
  "t1103_Bolus":"Bolus",
  "t1103_Basal_Bolus":"Basaal & Bolus",
  "t1103_Auto_Mode_Time_In_Range":"Auto Modus: Time In Range",
  "t1103_Time_below_range":"Tijd beneden Doelbereik",
  "t1103_Time_above_range":"Tijd boven Doelbereik",
  "t1103_Time_in_target_range":"Tijd binnen Doelbereik",
  "t1103_Incorrect_Password":"Onjuist wachtwoord, $1 Poging over, voer het juiste wachtwoord in.",
  "t1103_Incorrect_locked":"Mislukte pogingen overschrijden de limiet, het account is vergrendeld. Probeer het over $1 minuten opnieuw.",
  "t1104_The_data_is_from":"De gegevens zijn afkomstig van de EasySense-app of de EasyPatch-app.",
  "t1104_Privacy_Policy":"Privacybeleid en gebruiksvoorwaarden",
  "t1104_updated_privacy_policy":"We hebben onze privacybeleid en gebruiksvoorwaarden bijgewerkt. Lees deze aandachtig en ga akkoord met de nieuwe voorwaarden voordat u de EasyPatch gebruikt.",
  "t1104_Disagree":"Niet akkoord",
  "t1104_Agree":"Accepteer",
  "t1105_Upload_History":"Geschiedenis uploaden",
  "t1105_Delete_Data":"Verwijder data",
  "t1105_Target_Range":"Doel bereik",
  "t1105_request_to_view_your_data":"$1 verzoek om uw gegevens te bekijken.",
  "t1105_Recent_Updates":"Recente updates",
  "t1108_No_data":"Geen gegevens",
  "t1108_Pump_Bash_SN":"SN van de Pomp",
  "t1108_Transmitter_SN":"SN van de Zender",
  "t1112_Normal_Glucose":"Normale Glucose",
  "t1112_Manual_Bolus_or_Modified_Bolus":"Handmatige bolus of aangepaste bolus",
  "t1112_Auto_Mode_Started":"Auto Mode gestart",
  "t1112_Auto_Mode_Exit":"Auto Mode Exit",
  "t1112_Normal_Bolus":"Normale Bolus",
  "t1112_Extended_Bolus":"Verlengde Bolus",
  "t1112_Combo_Bolus":"Gecombineerde Bolus",
  "t1112_Carbs":"Koolhydraten",
  "t1112_Glucose":"Glucose",
  "t1112_BG":"BG",
  "t1112_Audio":"Geluid",
  "t1112_Tone":"Geluid",
  "t1112_Audio_Options":"Geluidsopties",
  "t1112_Weight_Unit":"Gewichtseenheid",
  "t1112_Height_Unit":"Hoogte-Eenheid",
  "t1112_Not_available":"Niet Beschikbaar",
  "t1112_Number":"Nummer",
  "t1112_days":"# dagen",
  "t1112_min":"min",
  "t1113_days":"dagen",
  "t1215_Security":"Veiligheid",
  "t1215_MFA":"Multi-factor authenticatie (MFA)",
  "t1215_Enter_verification_code":"Voer verificatiecode in",
  "t1215_Multi_factor_ON":"Multi-factor authenticatie is AAN. Verificatiecode is verzonden naar $1 Dien een verificatiecode in.",
  "t1215_Verification_code_incorrect":"Verificatiecode onjuist",
  "t1215_Show_Glucose_Value":"Glucosewaarde weergeven",
  "t1221_enter_verification_code":"Voer de 6-cijferige verificatiecode in die naar $1 is verzonden.",
  "t1221_Verification_Success":"Succesvol geverifieerd",
  "t1222_We_will_only_process":"We zullen uw gezondheidsinformatie alleen verwerken via de app/website van Medtrum met uw toestemming. ",
  "t1222_If_you_are_under_years":"Indien u jonger bent dan 16 jaar, heeft u toestemming van uw ouder of wettelijke voogd nodig voor registratie in de app.",
  "t1221_register_cn":"U heeft het recht om geen apparaatgegevens naar de app te uploaden, in welk geval de gegevens niet voor anderen toegankelijk zullen zijn. Als u ervoor kiest om u niet te registeren via de app/website van Medtrum, staat uw gezondheidsinformatie alleen op het apparaat zelf opgeslagen. ",
  "t1221_register_eu":"Als u ervoor kiest om uw Medtrum-account te registreren en gebruik te maken van de app via uw account, zal uw gezondheidsinformatie die staat opgeslagen in de app naar onze server in Europa worden geüpload en daar gedurende 2 jaar worden bewaard. U heeft het recht om geen apparaatgegevens naar de app te uploaden, in welk geval de gegevens niet voor anderen toegankelijk zullen zijn. Als u ervoor kiest om u niet te registeren via de app/website van Medtrum, staat uw gezondheidsinformatie alleen op het apparaat zelf opgeslagen.",
  "t1221_register_follow":"We zullen uw gezondheidsinformatie alleen verwerken via de app/website van Medtrum met uw toestemming. ",
  "t1222_Terms_of_Use":"de gebruiksvoorwaarden van Medtrum",
  "t1222_Privacy_Policy":"het privacybeleid van Medtrum",
  "t1222_Create_Account":"Account aanmaken",
  "t1222_Back":"Terug",
  "t1222_Verify_your_account":"Verifieer uw account",
  "t1222_please_check_your_account":"We sturen een verificatiecode naar $1, controleer uw account.",
  "t1222_I_Agree_to":"Ik ga akkoord met $1",
  "t1223_Invalid_Verification_Code":"Ongeldige verificatie code. Probeer het opnieuw.",
}

//export default {duMessages}



// WEBPACK FOOTER //
// ./src/lang/du.js